import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LessonMetadata = ({
  lesson,
  moduleTitle,
  isCompleted,
  onMarkComplete,
  canMarkComplete,
  onBookmark,
  isBookmarked,
}) => {
  return (
    <div className="bg-card rounded-lg p-6 space-y-4">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            {moduleTitle && (
              <span className="text-sm font-medium text-accent bg-accent/10 px-2 py-1 rounded-full">
                {moduleTitle}
              </span>
            )}
            {isCompleted && (
              <div className="flex items-center space-x-1 text-success">
                <Icon name="CheckCircle" size={16} />
                <span className="text-xs font-medium">Completed</span>
              </div>
            )}
          </div>
          <h1 className="text-2xl font-bold text-foreground mb-2">{lesson?.title}</h1>
        </div>

        <Button
          variant="ghost"
          size="icon"
          onClick={onBookmark}
          className={isBookmarked ? 'text-warning' : 'text-muted-foreground'}
          iconName={isBookmarked ? 'Bookmark' : 'BookmarkPlus'}
          iconSize={20}
        />
      </div>

      <div className="flex items-center space-x-3 pt-2">
        <Button
          variant={isCompleted ? 'outline' : 'default'}
          onClick={onMarkComplete}
          disabled={!canMarkComplete}
          iconName={isCompleted ? 'RotateCcw' : 'CheckCircle'}
          iconPosition="left"
          className="flex-1 sm:flex-none"
        >
          {isCompleted ? 'Mark Incomplete' : 'Mark as Complete'}
        </Button>
      </div>

      {!isCompleted && !canMarkComplete && (
        <div className="bg-warning/10 border border-warning/20 rounded-lg p-3">
          <div className="flex items-start space-x-2">
            <Icon name="Info" size={16} className="text-warning mt-0.5" />
            <p className="text-sm font-medium text-warning">
              Watch at least 80% of the video to unlock completion.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LessonMetadata;